export default "__VITE_ASSET__Cg$Eqt_D__"